"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomerDocument = useCustomerDocument;
var _auth = require("@ori/auth");
var _axios = require("@ori/axios");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _swr = _interopRequireDefault(require("swr"));
var _contexts = require("../../../contexts");
const axiosClient = _axios.axios.create();
const getEncodedFile = blob => URL.createObjectURL(blob);
function useCustomerDocument(customerId, documentId) {
  const {
    registrationId
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    globalApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi']);
  const {
    formattedToken
  } = (0, _auth.useToken)();
  const shouldFetch = Boolean(customerId !== null && documentId !== null && documentId !== undefined && documentId !== -1);
  const url = `${globalApiUrl}/customers/${customerId}/documents/${documentId}`;
  const {
    data: document
  } = (0, _swr.default)(shouldFetch ? url.toString() : null, async requestUrl => {
    if (!shouldFetch) {
      return undefined;
    }
    const headers = {
      'x-tenant-context': tenant,
      'x-registration-id': registrationId
    };
    headers.Authorization = formattedToken;
    const {
      data
    } = await axiosClient.get(requestUrl, {
      headers,
      responseType: 'blob'
    }).then(blob => blob).catch(error => error);
    return data;
  });
  return document === undefined ? undefined : getEncodedFile(document);
}